import * as types from '../constants/LotteryActionTypes'
import fetch from 'isomorphic-fetch'
import {__PREFIX__} from '../constants/UrlPrefix'

export function fetch_lotteries() {
	return function(dispatch){
		dispatch(request_lotteries());
		
		var request = new Request('' + __PREFIX__ + 'Lotteries.json', {credentials: 'include'});
		return fetch(request)
			.then(response => response.json())
			.then(json => {
				dispatch(receive_lotteries(json));
			})
	}
}

export function request_lotteries() {  
  return {
    type: types.REQUEST_LOTTERIES
  };
}

export function receive_lotteries(json){
	return  {
		type: types.RECEIVE_LOTTERIES,
		lotteries: json.data
	}
}

export function select_lottery(lottery){
	return {
		type: types.SELECT_LOTTERY,
		lottery: lottery
	}
}